import { useEffect } from 'react';

import useOrgGroupsByOrgUnitData from '../../../state/orgGroupsByOrgUnit/UseOrgGroupsByOrgUnitData';

const useOrgGroupCombobox = (orgUnitId) => {
  const { orgGroupsByOrgUnitState, getOrgGroupsByOrgUnit } = useOrgGroupsByOrgUnitData();

  useEffect(() => {
    if ((orgUnitId !== orgGroupsByOrgUnitState.orgUnitId || orgGroupsByOrgUnitState.isArrayLoaded === false)
      && orgGroupsByOrgUnitState.isArrayLoading === false) {
      getOrgGroupsByOrgUnit(orgUnitId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitId, orgGroupsByOrgUnitState]);

  return {
    orgGroupsByOrgUnitState
  };
};

export default useOrgGroupCombobox;
